import React from "react"
import { createRoot } from "react-dom/client"
import { Provider } from "react-redux"
import { persistStore } from "redux-persist"
import { PersistGate } from "redux-persist/integration/react"
import axios from "axios"
import { toast } from "react-toastify"
import store from "./store.js"
import App from "./App"
import reportWebVitals from "./reportWebVitals"
import "./bootstrap.min.css"
import "bootstrap/dist/js/bootstrap.min.js"
import "./main.js"
import "./index.css"

const container = document.getElementById("root")
const root = createRoot(container)

let persistor = persistStore(store)

let sessionExpired = false

const PENNYTREE_API = "api.mypennytree.com"

axios.interceptors.response.use(
  (response) => response,
  (error) => {
    const requestUrl = error.config?.url || ""
    const isPennyTree = requestUrl.includes(PENNYTREE_API)
    if (isPennyTree && error.response?.status === 401 && !sessionExpired) {
      const token = store.getState()?.admin2faLogin?.userInfo?.token?.access_token
      if (token) {
        sessionExpired = true
        store.dispatch({ type: "ADMIN_LOGOUT" })
        toast.error("Your session has expired. Please log in again.", { toastId: "session-expired" })
        setTimeout(() => {
          sessionExpired = false
          window.location.href = "/"
        }, 2000)
      }
    }
    return Promise.reject(error)
  }
)

root.render(
  <React.StrictMode>
    <Provider store={store}>
      <PersistGate persistor={persistor}>
        <App />
      </PersistGate>
    </Provider>
    ,
  </React.StrictMode>
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
